import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';
import { PasswordScoreMeter } from './PasswordScoreMeter';

interface IPasswordWithScoreInputsProps {
  passwordStatus: InputStatus;
  passwordScore: number | null;
  labelText: string;
  autoComplete?: string;
  onPasswordChange: (value: string) => void;
  onBlur: (value: string) => void;
}

export const PasswordWithScoreInputs = observer((props: IPasswordWithScoreInputsProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='register-password-inputs'>
      <ValidatedTextInput
        isRequired
        labelText={props.labelText}
        type={'password'}
        placeholder={t('enter_password')}
        onChange={props.onPasswordChange}
        onBlur={props.onBlur}
        isValid={props.passwordStatus.isValid}
        feedbacks={props.passwordStatus.errorCodes}
        enablePreview={true}
        autoComplete={props.autoComplete}
      >
        <PasswordScoreMeter score={props.passwordScore} />
      </ValidatedTextInput>
    </div>
  );
});
